const marketoFormsUtils = () => {
  const forms = document.querySelectorAll('.mktoForm');

  const loadMultipleForms = () => {
    if (forms.length > 1) {
      const listenForFirstFormLoading = setTimeout(
        () => {
          const firstForm = forms[0];

          if (firstForm.dataset.stylesReady === 'true') {
            forms.forEach((form) => {
              const currentForm = form;
              currentForm.dataset.stylesReady = 'true';

              clearTimeout(listenForFirstFormLoading);
            });
          }
        },
        200,
      );
    }
  };

  loadMultipleForms();
};

export default marketoFormsUtils;
